/* eslint-disable no-invalid-this */

import ApiService from './ApiService';

/**
 * @override
 */
class UserActionsService extends ApiService {
    /**
     * Comprobamos si el usuario tiene permisos de edición
     * @param {String} section Nombre de la sección a comprobar
     * @return {Boolean} Puede o no editar
     */
    canEdit(section) {
        const item = this.getUserPermissionSet().permission_objects.find( x => x.key_name === section );
        return item.value.edit ? true : false;
    }
    /**
     * Recogemos el permission_set de localstorage
     * @return {Object} Set de permisos del usuario loggeado
     */
    getUserPermissionSet() {
        const { permission_set } = JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS')))));
        return permission_set;
    }
    /**
     * Recogemos el número de notificaciones
     * @return {Object} Issues del usuario loggeado
     */
    getUserIssues() {
        const { issues } = JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS')))));
        return issues;
    }

}

const userActionsService = new UserActionsService();

export default userActionsService;
